import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { hasElements } from "Utils/Array";
import { isNullOrWhiteSpace } from "Utils/String";
import { projectsCloneDialog } from "Store/Actions";
import { selectSelectedOrActiveProjects } from "Store/Selectors/Projects";
import { IAction } from "./IAction";

export function useClone(): [boolean, IAction] {
  const dispatch = useDispatch();
  const selectedProjects = useSelector(selectSelectedOrActiveProjects);
  const allowClone = hasElements(selectedProjects)
    && selectedProjects.length <= 10
    && selectedProjects.every((selectedProject) => isNullOrWhiteSpace(selectedProject[`@originId`]));

  const onClone = useCallback(() => {
    if (!allowClone) {
      return;
    }
    dispatch(projectsCloneDialog(true));
  }, [allowClone, dispatch]);

  return [allowClone, onClone];
}
